import React from 'react'

const AmazingProductSection = () => {
    return (
        <>
            <div className="amezing-bx mt-4">
                <h3>
                    Amazing <span>Products Section</span>
                </h3>
                <a href="#">Compare NOW &gt;&gt;</a>
            </div>

        </>
    )
}

export default AmazingProductSection